module.exports = __webpack_public_path__ + "static/img/IAQPlacard.451a3d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IAQPlacard.png
// module id = 122
// module chunks = 1